import {IIcon} from "../../model";

export const search: IIcon = {
  id: 'SEARCH',
  svg: '<path d="M6.5 0a6.5 6.5 0 015 10.7l.2.3h.8l5 5-1.5 1.5-5-5v-.8l-.3-.3A6.5 6.5 0 116.5 0zm0 2C4 2 2 4 2 6.5S4 11 6.5 11 11 9 11 6.5 9 2 6.5 2z"/>'
}
